import GhostLoader from 'react-ghost-loader';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import {
  NA,
  OTS_SGM_MNG_AVG_RELEVANCE_PCTL,
  OTS_SGM_MNG_AVG_VALUE_PCTL,
  OTS_SGM_MNG_MATCH_PCT_PCTL,
  OTS_SGM_MNG_PAID_PCT_PCTL,
} from '../../../content';
import { SegmentDetail } from '../types';
import { isNil } from 'lodash';
import * as Styled from './index.styles';

interface SegmentDetailPercentileCardsProps {
  segmentDetail?: SegmentDetail;
  loading: boolean;
}

const PERCENTILE_CARDS = [
  {
    title: OTS_SGM_MNG_AVG_RELEVANCE_PCTL,
    dataKey: 'avgRelevancePercentile' as const,
    recommendationKey: 'avgRelevancePercentileRecommendation' as const,
  },
  {
    title: OTS_SGM_MNG_AVG_VALUE_PCTL,
    dataKey: 'avgValuePercentile' as const,
    recommendationKey: 'avgValuePercentileRecommendation' as const,
  },
  {
    title: OTS_SGM_MNG_MATCH_PCT_PCTL,
    dataKey: 'matchedPercentile' as const,
    recommendationKey: 'matchedPercentileRecommendation' as const,
  },
  {
    title: OTS_SGM_MNG_PAID_PCT_PCTL,
    dataKey: 'paidPercentile' as const,
    recommendationKey: 'paidPercentileRecommendation' as const,
  },
];

const formatPercentile = (value: number | string | null | undefined): string => {
  if (isNil(value) || typeof value !== 'number') return NA;
  return `${Number(value).toFixed(2)}%`;
};

const SegmentDetailPercentileCards: React.FC<
  SegmentDetailPercentileCardsProps
> = ({ segmentDetail, loading }) => {
  return (
    <Grid container spacing={2}>
      {PERCENTILE_CARDS.map((card, index) => {
        const value = loading
          ? undefined
          : (segmentDetail?.[card.dataKey] as number | undefined);
        const formattedValue = loading ? null : formatPercentile(value);
        const recommendation =
          loading || !segmentDetail
            ? ''
            : (segmentDetail[card.recommendationKey] as string | null | undefined) ?? '';

        return (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Styled.PercentileCard>
              <Styled.PercentileLabel>{card.title}</Styled.PercentileLabel>
              <Styled.PercentileValue>
                {loading ? (
                  <GhostLoader height="32px" width="80px" />
                ) : (
                  formattedValue || NA
                )}
              </Styled.PercentileValue>
              <Styled.PercentileRecommendation>
                {recommendation}
              </Styled.PercentileRecommendation>
            </Styled.PercentileCard>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default SegmentDetailPercentileCards;
